import React, { useState, useEffect, useRef } from 'react';
import classes from './TripStays.module.css';

const TripStays = ({
    tripStays
}) => {

    const [currentStep, setCurrentStep] = useState(0);

    const handleArrowClickLeft = () => {
        if(currentStep == 0) return;
        setCurrentStep(currentStep - 1);
    };

    const handleArrowClickRight = () => {
        if(currentStep==tripStays.length-1) return;
        setCurrentStep(currentStep + 1);
    };

    // const HtmlContent = ({ content }) => {
    //     return (
    //       <p dangerouslySetInnerHTML={{ __html: content }} />
    //     );
    //   };

    return (
        <>
            <p className='mt-[1vh] text-[6vw] font-[500] mb-[2vh] ml-[8vw]'>Our Stays</p>
            <div className='w-full flex flex-row'>
                <div className={classes["swipe-arrow-container"]}>
                    {currentStep == 0 || tripStays.length==1 ?
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="#FFFFFF" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                            <path d="M10 19l-7-7 7-7" />
                        </svg>
                        :
                        <svg onClick={handleArrowClickLeft} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="#e65439" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                            <path d="M10 19l-7-7 7-7" />
                        </svg>
                    }

                </div>
                <div style={{ boxShadow: "0px 7px 8px rgba(230, 84, 57, 0.2)" }} className='w-[80%] min-h-[50vh] flex flex-col mb-[4vh] rounded-[25px] p-[10px] overflow-x-hidden'>
                    <img className='w-full h-[25vh] object-cover rounded-[20px] mb-[1vh]' src={tripStays[currentStep].stayImg} alt="" />
                    <div className='w-full mb-[2vh]'>
                        <p className='text-[4vw] font-bold mb-[0.1vh]'>{tripStays[currentStep].stayName}</p>
                        <p className='text-[3.5vw]'>{tripStays[currentStep].stayDesc}</p>
                    </div>
                    <div style={{display:`${tripStays.length<=1?"none":""}`}} className='w-full flex flex-row justify-center mt-[auto] mb-[0.8vh] space-x-2'>
                        {tripStays.map((stay,index) => (<div style={{backgroundColor:`${index==currentStep?"#e65439":""}`}} className='w-[2.5vw] h-[2.5vw] rounded-full border-[1px] border-[#e65439]'
                         onClick ={ () => {setCurrentStep(index)}}
                        >

                        </div>))}
                    </div>
                </div>
                <div className={classes["swipe-arrow-container"]}>
                    {
                        currentStep == tripStays.length-1 || tripStays.length==1 ?
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="#FFFFFF" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                                <path d="M14 5l7 7-7 7" />
                            </svg>
                            :
                            <svg onClick={handleArrowClickRight} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="#e65439" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                                <path d="M14 5l7 7-7 7" />
                            </svg>
                    }

                </div>
            </div>
        </>
    )
}


export default TripStays;
